// Visualizações com Container de Checkout

const publicRoutes = [
  {
    path: '/sale-checkout/:id',
    name: 'Checkout',
    component: () => import('@/view/pages/public/checkout/Overview.vue'),
  },
  {
    path: '/sale-checkout/:id/detail',
    name: 'CheckoutDetail',
    component: () => import('@/view/pages/public/checkout/Details.vue'),
    props: true,
  },
  {
    path: '/checkout',
    component: () => import('@/view/Layouts/AuthContainer/AuthContainer.vue'),
    children: [
      {
        name: 'Criação de Deposito Público',
        path: '/checkout/:document',
        component: () => import('@/view/pages/public/PublicDeposit/PublicDeposit.vue'),
      },
    ],
  },
  {
    path: '/pagador',
    component: () => import('@/view/Layouts/AuthContainer/AuthContainer.vue'),
    children: [
      {
        path: '',
        name: 'Área do Pagador',
        props: true,
        component: () => import('@/view/pages/public/Payments/Public.vue'),
      },
      {
        path: '/pagador/boleto/:id',
        name: 'Visualização de boleto publico',
        props: true,
        component: () => import('@/view/pages/shared/printables/invoices/BoletoPublic.vue'),
      },
    ],
  },
]

export default publicRoutes
